(function () {
  'use strict';

  function initQuoteModal(modal) {
    var openBtn = document.querySelector('[data-quote-modal="' + modal.id + '"]');
    if (!openBtn) return;

    // Move modal to body to avoid transform stacking context issues
    if (modal.parentNode !== document.body) {
      document.body.appendChild(modal);
    }

    var form = modal.querySelector('.quote-modal__form');
    var successEl = modal.querySelector('.quote-modal__success');
    var errorsEl = modal.querySelector('.quote-modal__errors');
    var submitBtn = modal.querySelector('.quote-modal__submit');
    var closeEls = modal.querySelectorAll('[data-quote-close]');

    function open() {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () {
        var firstInput = modal.querySelector('input:not([readonly]), textarea');
        if (firstInput) firstInput.focus();
      }, 60);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', open);

    closeEls.forEach(function (el) {
      el.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
    });

    // Async submit — stay in modal and show feedback
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        // Clear previous errors
        if (errorsEl) errorsEl.textContent = '';

        // Show loading state on button
        var originalLabel = submitBtn ? submitBtn.textContent : '';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending…';
        }

        var data = new FormData(form);

        fetch(form.action || window.location.pathname, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
          body: data
        })
        .then(function (res) {
          if (!res.ok) throw new Error('server_error');
          return res.text();
        })
        .then(function () {
          // Success: hide form, show success message
          form.style.display = 'none';
          if (successEl) {
            successEl.hidden = false;
            successEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        })
        .catch(function () {
          // Error: restore button and show message
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalLabel;
          }
          if (errorsEl) {
            errorsEl.textContent = 'Something went wrong. Please try again.';
          }
        });
      });
    }
  }

  function init() {
    document.querySelectorAll('.quote-modal').forEach(initQuoteModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
